import React, { Component } from "react";

import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

import { Row } from "react-flexbox-grid";
import NumericInput from "react-numeric-input";

import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import InputLabel from "@material-ui/core/InputLabel";
import { Tooltip } from "@material-ui/core";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const allErrorAlerts = [
  {
    name: "All Errors",
    tip: "Get an alert every time there is a machine error.",
    id: 1
  },
  {
    name: "Repetitive Errors",
    tip: "Monitor repetitive errors over a designated time interval.",
    id: 2
  },
  {
    name: "Inactive Machine",
    tip: "Alerts if a machine has not had a successful transaction after an error occurs.",
    id: 3
  }
];

const intervals = ["Day", "Week", "Month", "Year"];

class ErrorForm extends Component {
  render() {
    const {classes} = this.props;

    /* Select List */
    let alertList = allErrorAlerts.map((alert, index) => (
        <MenuItem key={index} value={alert.name}>
          <Tooltip key={index} title={alert.tip} placement="top">
            <ListItemText primary={alert.name} />
          </Tooltip>
        </MenuItem>
    ));

    let intervalList = intervals.map((interval, index) => (
      <MenuItem key={index} value={index}>
          <ListItemText primary={interval} />
      </MenuItem>
    ))

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="select-multiple-checkbox">
              Select Error Alert
            </InputLabel>
            <Select
              name="selectedErrorAlertId"
              value={this.props.selectedErrorAlert}
              onChange={this.props.handleErrorAlertChange}
              input={<Input id="select-multiple-checkbox" />}
              MenuProps={MenuProps}
            >
              {alertList}
            </Select>
          </FormControl>
        </GridItem>
        {this.props.selectedErrorAlert === "Repetitive Errors" && (
          <div>
          <GridItem xs={12} sm={12} md={6}>
            <FormControl className={classes.formControl}>
              <Tooltip title={"Interval to check for repeats"} placement="top" >
                <InputLabel htmlFor="select-multiple-checkbox">
                  Select Interval
                </InputLabel>
              </Tooltip>
              <Select
                name="selectedIntervalId"
                value={this.props.selectedErrorInterval}
                onChange={this.props.handleErrorIntervalChange}
                input={<Input id="select-multiple-checkbox" />}
                MenuProps={MenuProps}
              >
                {intervalList}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <br/>
            <Tooltip title={"How many errors are acceptable in the selected interval before sending an alert"} placement="top">
              <Row center="xs">
                <InputLabel>
                  Number of Repeats
                </InputLabel>
              </Row>
            </Tooltip>
            <NumericInput
              mobile
              min={0}
              max={168}
              size={100}
              value={this.props.errorRepeats}
              onChange={this.props.handleErrorRepeatsChange}
              style={{
                width: "100%",
                wrap: {
                  marginBottom: "10px"
                },
                input: {
                  display: "block",
                  fontWeight: 100,
                  width: "100%",
                  height: "35px"
                }
              }}
            />
          </GridItem>
        </div>
        )}
        {this.props.selectedErrorAlert === "Inactive Machine" && (
          <GridItem xs={12} sm={12} md={3}>
          <br/>
          <Tooltip title={"How many hours to wait to send alert"} placement="top">
            <Row center="xs">
              <InputLabel>
                Delay
              </InputLabel>
            </Row>
          </Tooltip>
          <NumericInput
            mobile
            min={0}
            max={168}
            size={100}
            value={this.props.errorDelay}
            onChange={this.props.handleErrorDelayChange}
            style={{
              width: "100%",
              wrap: {
                marginBottom: "10px"
              },
              input: {
                display: "block",
                fontWeight: 100,
                width: "100%",
                height: "35px"
              }
            }}
          />
        </GridItem>
        )}
      </GridContainer>
    );
  }
}
export default ErrorForm;



// WEBPACK FOOTER //
// ./src/components/Alerts/ErrorForm.jsx